import { useContext } from 'react'

import { BreakpointContext } from '@src/components/breakpoint/Breakpoints'

export function useBreakpoints() {
    return useContext(BreakpointContext)
}
